<template>
    <div
        class="draft-numbering-block"
        :class="{ 'draft-numbering-block--is-ready': isReadyToActivateDraftNumbering }"
    >
        <p class="typographies-paragraph-small-regular" v-html="description" />
        <div class="draft-numbering-block__key-figures">
            <div class="draft-numbering-block__figure">
                <div class="draft-numbering-block__figure-count typographies-display-medium">
                    {{ invoiceCount }}
                </div>
                <div
                    class="draft-numbering-block__figure-type typographies-paragraph-caps-x-small-bold"
                >
                    {{ $t.n__('common.labels.invoice.plural', null, invoiceCount, invoiceCount) }}
                </div>
                <CompassButton
                    v-if="!isReadyToActivateDraftNumbering && invoiceCount > 0"
                    :label="$t.__('common.actions.process')"
                    leftIcon="arrow-right"
                    size="small"
                    type="tertiary"
                    @click="goToFilteredListing('invoice')"
                />
            </div>
            <div class="draft-numbering-block__figure">
                <div class="draft-numbering-block__figure-count typographies-display-medium">
                    {{ creditNoteCount }}
                </div>
                <div
                    class="draft-numbering-block__figure-type typographies-paragraph-caps-x-small-bold"
                >
                    {{
                        $t.n__('common.labels.credit_note', null, creditNoteCount, creditNoteCount)
                    }}
                </div>
                <CompassButton
                    v-if="!isReadyToActivateDraftNumbering && creditNoteCount > 0"
                    :label="$t.__('common.actions.process')"
                    leftIcon="arrow-right"
                    size="small"
                    type="tertiary"
                    @click="goToFilteredListing('creditnote')"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, inject } from 'vue';
import { useRouter } from 'vue-router';
// Props
const props = defineProps({
    invoiceCount: {
        type: Number,
        default: 0,
    },
    creditNoteCount: {
        type: Number,
        default: 0,
    },
});

const router = useRouter();

// Injected
const $t = inject('$t');

// Ref
const boldWithFontClassSmall = `<strong class="typographies-paragraph-small-bold">`;

// Computed
const isReadyToActivateDraftNumbering = computed(() => {
    return props.invoiceCount === 0 && props.creditNoteCount === 0;
});

const description = computed(() => {
    const translationKey = isReadyToActivateDraftNumbering.value
        ? 'settings.sellsymodule.invoicing.conformity.draft_numbering.count.information_ok'
        : 'settings.sellsymodule.invoicing.conformity.draft_numbering.count.information';

    return $t.__(translationKey, {
        boldStart: boldWithFontClassSmall,
        boldEnd: '</strong>',
    });
});

const goToFilteredListing = (documentType) => {
    const filters = {
        step: { choices: ['draft'] },
    };

    const resolved = router.resolve({ name: documentType });

    window.open(
        `${resolved.href}?showDraftNumberingModal=1&filter=${encodeURIComponent(JSON.stringify(filters))}`,
        '_self',
    );
};
</script>
<style scoped lang="scss">
.draft-numbering-block {
    background: var(--colors-common-background-decorative-orange);
    border-radius: var(--spacing-0);
    color: var(--colors-component-text-tag-orange);
    padding: var(--spacing-3);

    &--is-ready {
        background: var(--colors-common-background-success-subtle);
        color: var(--colors-component-text-tag-green);
    }

    p {
        color: var(--colors-common-text-standard-default);
        margin: 0 0 var(--spacing-3);
    }

    &__key-figures {
        align-items: start;
        display: flex;
        gap: var(--spacing-1);
    }

    &__figure {
        align-items: center;
        display: flex;
        flex: 1;
        flex-direction: column;

        &-type {
            margin-bottom: var(--spacing-2);
        }
    }
}
</style>
